/**
 * GSAP a richiesta. `@/lib/gsap` registra i plugin e vale una cinquantina di
 * KB compressi: importato in cima a un componente montato dal root layout
 * (il dialog dell'exit intent) o da ogni articolo (il dock) finiva nel chunk
 * condiviso di tutte le pagine, anche dove nessuno anima niente, e si
 * contendeva il thread principale con l'idratazione. Da qui si scarica la
 * prima volta che un'animazione parte davvero; le pagine con hero e demo
 * continuano a importarlo in cima, come prima.
 *
 * Chi lo usa nasconde da sé lo stato iniziale (un `opacity: 0` in linea) nel
 * `useLayoutEffect`, prima del primo disegno: fra il montaggio e l'arrivo di
 * GSAP passano decine di millisecondi, e un elemento che compare e sparisce
 * si vede.
 */
type GsapModule = typeof import('./gsap');

let pending: Promise<GsapModule> | null = null;

export function loadGsap(): Promise<GsapModule> {
  pending ??= import('./gsap');
  return pending;
}
